import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
  QueryList,
  ViewChildren
} from '@angular/core';
import {Overlayable} from 'src/app/interfaces/overlayable';
import {FavoritesService} from "../favorites.service";
import {OverlayService} from "../../overlay/overlay.service";
import {Router} from "@angular/router";
import {NotificationService} from "../../atoms/notification/notification.service";
import {CdColor} from "../../enums/cd-color";

@Component({
  selector: 'brt-load-favorites',
  templateUrl: './load-favorites.component.html',
  styleUrls: ['./load-favorites.component.scss']
})
export class LoadFavoritesComponent implements Overlayable, AfterViewInit {

  @ViewChildren('inputEl') inputEls: QueryList<ElementRef> = new QueryList<ElementRef>();
  @Output("onClosed") onClosed = new EventEmitter<boolean>();
  codeLength = 4;
  code: string[] = new Array(this.codeLength).fill("");
  isConfirmEnabled = false;

  isLoading = false;
  submitButtonLabel = "Ok";

  cmdPressed = false;

  @HostListener("keydown", ['$event']) onCmdPressed($event: KeyboardEvent) {
    if ($event.key == "Meta" || $event.key == "Control") this.cmdPressed = true;
  }

  @HostListener("keyup", ['$event']) onCmdReleased($event: KeyboardEvent) {
    if ($event.key == "Meta" || $event.key == "Control") this.cmdPressed = false;
  }


  constructor(private favorites: FavoritesService, private notificationService: NotificationService, private overlay: OverlayService, private router: Router) {
  }

  ngAfterViewInit() {
    if(this.inputEls.get(0)) {
      const htmlEl = this.inputEls.get(0)?.nativeElement as HTMLInputElement;
      htmlEl.focus();
    }
  }

  submit() {
    const codeStr = this.code.join("");
    if(codeStr.length === this.codeLength) {
      // console.log("Submitting ", this.code.join(""));
      this.isLoading = true;
      this.submitButtonLabel = "Wird geladen...";

      try {
        this.favorites.load(codeStr).then((response) => {
          if(!response) {
            this.overlay.alertMessage("Merkliste", "Merkliste konnte nicht gefunden werden");
          } else {
            this.router.navigateByUrl("/merkliste");
          }
          this.onClosed.emit(true);

        })
      } catch (err) {
        console.warn(err);
      }
    }
  }

  afterInputChange($event: KeyboardEvent, idx: number) {
    const htmlEl = $event.target as HTMLInputElement;
    $event.preventDefault();

  }

  beforeInputChange($event: KeyboardEvent, idx: number) {
    const htmlEl = $event.target as HTMLInputElement;
    const oldValue = htmlEl.value;

    if(this.cmdPressed) {
      return;
    } else if($event.key === "Enter") {
      $event.preventDefault();
      this.submit();
    } else if($event.key === "Backspace" || $event.key === "Delete") {
      this.code[idx] = "";

      if(oldValue.length === 0 && idx > 0) {
        const prevInputEl = this.inputEls.get(idx - 1)?.nativeElement as HTMLInputElement;
        prevInputEl.focus();
      }
      return;

    } else if(!this.validateSymbol($event.key)) {
      $event.preventDefault();
      return;
    }


    if(oldValue.length === 1) {
      $event.preventDefault();
      return;
    }

    this.code[idx] = $event.key.toUpperCase();
    htmlEl.value = this.code[idx];

    this.isConfirmEnabled = this.code.join("").length === this.codeLength;

    if(idx < (this.codeLength - 1)) {
      const nextInputEl = this.inputEls.get(idx + 1)?.nativeElement as HTMLInputElement;
      window.requestAnimationFrame(() => {
        nextInputEl.focus();
      });
    }

    $event.preventDefault();

  }

  onCodeChange() {
    // console.log(this.code);
  }

  validateSymbol(symbol: string): boolean {
    if(symbol.length !== 1) return false;
    return symbol.match(/[a-z0-9]/i) !== null;
  }

  onPaste(event: ClipboardEvent, idx: number) {

    event.preventDefault();

    // @ts-ignore
    let clipboardData = event.clipboardData || window.clipboardData;
    let pastedText = clipboardData.getData('text');

    if(pastedText.length === 4) {
      this.code[0] = pastedText[0];
      this.code[1] = pastedText[1];
      this.code[2] = pastedText[2];
      this.code[3] = pastedText[3];

      if(typeof this.inputEls.get(0) !== "undefined") {
        // @ts-ignore
        this.inputEls.get(0).nativeElement.value = pastedText[0];
      }

      if(typeof this.inputEls.get(1) !== "undefined") {
        // @ts-ignore
        this.inputEls.get(1).nativeElement.value = pastedText[1];
      }

      if(typeof this.inputEls.get(2) !== "undefined") {
        // @ts-ignore
        this.inputEls.get(2).nativeElement.value = pastedText[2];
      }

      if(typeof this.inputEls.get(3) !== "undefined") {
        // @ts-ignore
        this.inputEls.get(3).nativeElement.value = pastedText[3];
      }

      this.isConfirmEnabled = true;

    } else {
      this.notificationService.push("Der Code muss genau 4 Zeichen lang sein.", CdColor.RED, "");
    }

  }
}
